// Generated by genversion.
export const name = '@lindberg/modelviewer'
export const version = '1.31.3'
